import { useContext, useEffect } from 'react';
import { exitContext } from 'src/contexts/exit';

export function useBeforeUnload(shouldPreventUnload = true) {
    const { setShouldPreventUnload } = useContext(exitContext);
    useEffect(() => {
        setShouldPreventUnload(shouldPreventUnload);
        return () => setShouldPreventUnload(false);
    }, [setShouldPreventUnload, shouldPreventUnload]);
}
